import { ScrollFadeIn } from "@/components/effects/ScrollFadeIn";
import { Marquee } from "@/components/ui/marquee";

const techStack = [
  { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
  { name: "Next.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg" },
  { name: "TypeScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" },
  { name: "Python", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
  { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
  { name: "PostgreSQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
  { name: "Tailwind", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg" },
  { name: "Figma", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" },
];

const TechStack = () => {
  return (
    <section className="py-16 px-4 overflow-hidden relative">
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

      <ScrollFadeIn>
        <div className="text-center mb-10">
          <p className="text-sm text-muted-foreground font-medium uppercase tracking-wider">
            Built with modern technology
          </p>
        </div>
      </ScrollFadeIn>

      <Marquee
        items={techStack}
        speedSeconds={22}
        renderItem={(tech) => (
          <div className="flex items-center justify-center mx-8 flex-shrink-0 group">
            <div className="flex items-center gap-3 tech-logo">
              <img
                src={tech.logo}
                alt={tech.name}
                loading="lazy"
                decoding="async"
                className="w-10 h-10 object-contain"
              />
              <span className="text-sm font-medium text-muted-foreground">{tech.name}</span>
            </div>
          </div>
        )}
      />
    </section>
  );
};

export default TechStack;
